export default __webpack_public_path__ + "static/media/searchWhite.7323df73.svg";